module.exports = "/_next/static/images/carrierImage-09a51625a7b7c34d4646bc50fce6746b.png.webp";